<template>
  <div hidden style="border: 1px solid black">
    <div style="padding-left: 5px; padding-right: 5px">
      <table
        style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 15px;
          "
      >
        <tbody style="border: 1px solid black;">
          <tr>
            <td
              rowspan="2"
              style="text-align: left; border: 1px solid black; width:100px;"
            >
              <div v-if="item.shopImageUrl" style="text-align: center;">
                <img :src="item.shopImageUrl" width="80px" />
              </div>
            </td>
            <td
              rowspan="2"
              style="text-align: center; font-weight: bold; border: 1px solid black; width: 250px;"
            >
              {{ item.shopName }}
            </td>
            <td
              style="text-align: left; font-weight: bold; border-top: 1px solid black; border-left: 1px solid black; padding-left: 20px; padding-top: 10px; width: 100px;"
            >
              IssueDate :
            </td>
            <td
              style="text-align: left;  border-top: 1px solid black; border-right: 1px solid black; padding-top: 10px; "
            >
              {{ item.issueDateInMilliSeconds | formatMsDate }}
            </td>
          </tr>
          <tr>
            <td
              style="text-align: left; font-weight: bold; border-bottom: 1px solid black;border-left: 1px solid black;  padding-left: 20px; padding-bottom: 10px; "
            >
              IssueNo :
            </td>
            <td
              style="text-align: left; border-bottom: 1px solid black;border-right: 1px solid black; padding-bottom: 10px; "
            >
              {{ item.issueNo }}
            </td>
          </tr>
          <tr>
            <td
              colspan="4"
              style="text-align: center; font-weight: bold; font-size: medium;border: 1px solid black; padding: 5px;"
            >
              Production Order
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="height: 10px"></div>

    <div style="padding-left: 5px; padding-right: 5px">
      <table
        style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 15px;
          "
      >
        <tbody style="border: 1px solid black;">
          <tr>
            <td
              style="text-align: left; border-right: 1px solid black; padding-top: 10px; padding-left: 5px; font-weight: bold; "
            >
              Product Name
            </td>
            <td
              style="text-align: center; border-right: 1px solid black; padding-top: 10px; font-weight: bold; "
            >
              PO Size
            </td>
            <td
              style="text-align: center; border-right: 1px solid black; padding-top: 10px; font-weight: bold; "
            >
              Page
            </td>
            <td
              style="text-align: left; border-right: 1px solid black; padding-top: 10px;padding-left: 5px; font-weight: bold; "
            >
              Po No:
            </td>
            <td
              style="text-align: left; border-right: 1px solid black; padding-top: 10px; padding-left: 5px; font-weight: bold; "
            >
              Product Code
            </td>
          </tr>
          <tr>
            <td
              style="text-align: left; border-right: 1px solid black; padding-top: 10px; padding-bottom: 10px; padding-left: 5px;"
            >
              {{ item.productName }}
            </td>
            <td
              style="text-align: center; border-right: 1px solid black; padding-top: 10px; padding-bottom: 10px;"
            >
              {{ (item.qty * item.factor) | decFormat(6) }}
            </td>
            <td
              style="text-align: center; border-right: 1px solid black; padding-top: 10px; padding-bottom: 10px;"
            >
              <!-- Page -->
            </td>
            <td
              style="text-align: center; border-right: 1px solid black; padding-top: 10px; padding-bottom: 10px;"
            >
              {{ item.poNo }}
            </td>
            <td
              style="text-align: left; border-right: 1px solid black; padding-top: 10px; padding-bottom: 10px; padding-left: 5px;"
            >
              {{ item.productCode }}
            </td>
          </tr>
          <tr style="border-top: 1px solid black;">
            <td
              style="text-align: center; border-right: 1px solid black; padding-top: 10px; padding-left: 5px; font-weight: bold; "
            >
              Batch/Lot No:
            </td>
            <td
              style="text-align: center; border-right: 1px solid black; padding-top: 10px; font-weight: bold; "
            >
              Batch/Lot Size:
            </td>
            <td
              colspan="2"
              style="text-align: center; border-right: 1px solid black; padding-top: 10px; font-weight: bold; "
            >
              Manufacturing Date
            </td>
            <td
              style="text-align: center; border-right: 1px solid black; padding-top: 10px; padding-left: 5px; font-weight: bold; "
            >
              Exp Date
            </td>
          </tr>
          <tr>
            <td
              style="text-align: center; border-right: 1px solid black; padding-top: 10px; padding-bottom: 10px; padding-left: 5px;"
            >
              {{ item.batchNo }}
            </td>
            <td
              style="text-align: center; border-right: 1px solid black; padding-top: 10px; padding-bottom: 10px;"
            >
              {{ item.productionProductUnitFactor }}'{{ item.productionProductUnitName }} x {{ item.productionQty * item.productionProductUnitFactor }}
            </td>
            <td
              colspan="2"
              style="text-align: center; border-right: 1px solid black; padding-top: 10px; padding-bottom: 10px;"
            >
              <span v-if="item.mfgDateInMilliSeconds">
                {{ item.mfgDateInMilliSeconds | formatMsDate }}
              </span>
              <span v-else>
                <br />
              </span>
            </td>
            <td
              style="text-align: center; border-right: 1px solid black; padding-top: 10px; padding-bottom: 10px;"
            >
              <span v-if="item.expDateInMilliSeconds">
                {{ item.expDateInMilliSeconds | formatMsDate }}
              </span>
              <span v-else>
                <br />
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="padding-left: 5px; padding-right: 5px">
      <table
        style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 15px;
          "
      >
        <tbody>
          <tr>
            <td
              style="text-align: left; width: 10%; padding-left: 20px; padding-top: 20px;"
            >
              To
            </td>
            <td
              style="text-align: left; width: 40%; padding-left: 20px; padding-top: 20px;"
            >
              {{ item.toDepartmentName }} Department
            </td>
            <td
              style="text-align: left; width: 10%; padding-left: 20px; padding-top: 20px;"
            >
              Remark
            </td>
            <td
              style="text-align: left; width: 40%; padding-left: 20px; padding-top: 20px;"
            >
              {{ item.remark }}
            </td>
          </tr>
          <tr>
            <td
              style="text-align: left; width: 10%; padding-left: 20px; padding-top: 10px; padding-bottom: 20px;"
            >
              From
            </td>
            <td
              style="text-align: left; width: 40%; padding-left: 20px; padding-top: 10px; padding-bottom: 20px;"
            >
              {{ item.fromDepartmentName }} Department
            </td>
            <td
              style="text-align: left; width: 10%; padding-left: 20px; padding-top: 10px; padding-bottom: 20px;"
            >
              Signature of Head
            </td>
            <td
              style="text-align: left; width: 40%; padding-left: 20px; padding-top: 10px; padding-bottom: 20px;"
            >
              <!-- Signature of Head -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- item details -->
    <div style="height: 10px"></div>
    <div style="padding-left: 5px; padding-right: 5px">
      <table
        style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 15px;
            border: 1px solid black;
          "
      >
        <thead
          style="border-bottom: 1px solid black; border-top: 1px solid black"
        >
          <tr>
            <th
              style="text-align: center; border-right: 1px solid black; width: 50px"
            >
              {{ "No" }}
            </th>
            <th style="text-align: center; border-right: 1px solid black;">
              {{ "Materials" }}
            </th>
            <th style="text-align: center; border-right: 1px solid black;">
              {{ "Bin" }}
            </th>
            <th style="text-align: center; border-right: 1px solid black;">
              {{ "Qc No" }}
            </th>
            <th style="text-align: center; border-right: 1px solid black;">
              {{ "Unit" }}
            </th>
            <th style="text-align: center; border-right: 1px solid black;">
              {{ "Quantity" }}
            </th>
            <th style="text-align: center; border-right: 1px solid black;">
              {{ "Special Instruction" }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(detail, index) in item.productionOrderDetailList"
            :key="index"
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <td
              style="text-align: center; width: 25px; border-right: 1px solid black; padding-top: 10px;"
            >
              {{ index + 1 }}
            </td>
            <td
              style="text-align: center; border-right: 1px solid black; width: 150px; padding-top: 10px;"
            >
              {{ detail.itemProductName }}
            </td>
            <td
              style="text-align: center; border-right: 1px solid black; width: 150px; padding-top: 10px;"
            >
              {{ detail.binName }}
            </td>
            <td
              style="text-align: center; border-right: 1px solid black; width: 150px; padding-top: 10px;"
            >
              {{ detail.qcNo }}
            </td>
            <td
              style="text-align: center; border-right: 1px solid black; width: 150px; padding-top: 10px;"
            >
              {{ detail.factorUnitName }}
            </td>
            <td
              style="text-align: center; border-right: 1px solid black; width: 150px; padding-top: 10px;"
            >
              {{ detail.itemQty | decFormat(6) }}
            </td>
            <td
              style="text-align: center; border-right: 1px solid black; width: 300px; padding-top: 10px;"
            >
              {{ detail.sepcialInstruction }}
            </td>
          </tr>
        </tbody>
      </table>
      <div style="height: 10px"></div>
    </div>
    <div style="height: 10px"></div>

    <div style="padding-left: 5px; padding-right: 5px">
      <table
        style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 15px;
          "
      >
        <tbody style="border: 1px solid black;">
          <tr>
            <td
              style="text-align: center; border: 1px solid black; font-weight: bold; width: 15%; padding-top: 5px; padding-bottom: 5px;"
            ></td>
            <td
              style="text-align: center; border: 1px solid black; font-weight: bold;"
            >
              Name
            </td>
            <td
              style="text-align: center; border: 1px solid black; font-weight: bold;"
            >
              Position
            </td>
            <td
              style="text-align: center; border: 1px solid black; font-weight: bold;"
            >
              Signature
            </td>
            <td
              style="text-align: center; border: 1px solid black; font-weight: bold;"
            >
              Date
            </td>
          </tr>
          <tr>
            <td
              style="text-align: left; border: 1px solid black; font-weight: bold; width: 15%; padding-top: 5px; padding-bottom: 5px;"
            >
              Prepared By
            </td>
            <td style="text-align: center; border: 1px solid black;"></td>
            <td style="text-align: center; border: 1px solid black;"></td>
            <td style="text-align: center; border: 1px solid black;"></td>
            <td style="text-align: center; border: 1px solid black;"></td>
          </tr>
          <tr>
            <td
              style="text-align: Left; border: 1px solid black; font-weight: bold; width: 15%; padding-top: 5px; padding-bottom: 5px;"
            >
              Review By
            </td>
            <td style="text-align: center; border: 1px solid black;"></td>
            <td style="text-align: center; border: 1px solid black;"></td>
            <td style="text-align: center; border: 1px solid black;"></td>
            <td style="text-align: center; border: 1px solid black;"></td>
          </tr>
          <tr>
            <td
              style="text-align: left; border: 1px solid black; font-weight: bold; width: 15%; padding-top: 5px; padding-bottom: 5px;"
            >
              Approved By
            </td>
            <td style="text-align: center; border: 1px solid black;"></td>
            <td style="text-align: center; border: 1px solid black;"></td>
            <td style="text-align: center; border: 1px solid black;"></td>
            <td style="text-align: center; border: 1px solid black;"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: "productionOrderDetailPrint",
  props: {
    item: Object,
  },
};
</script>
